export default __webpack_public_path__ + "static/media/carlton-whatsapp-qr.c24a796a.jpg";